module.exports = __webpack_public_path__ + "images/customer-images/customer-image1.png";